/** Public website pages (besides "/"): tag manager, consent banner and the website theme toggle. Leaf module. */
export const WEBSITE_PATH_PREFIXES = [
  "/preise",
  "/features",
  "/compare",
  "/integrations",
  "/demo",
  "/careers",
  "/impressum",
  "/datenschutz",
] as const;

/** Booked state of /demo, set by pushState. Google's "Termin gebucht" trigger matches this path. */
export const DEMO_THANKS_PATH = "/demo/thanks";

export function isWebsitePath(pathname: string): boolean {
  return (
    pathname === "/" ||
    WEBSITE_PATH_PREFIXES.some(
      (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`),
    )
  );
}

/** Staff login follows the website's light/dark choice too (no toggle there). Portal hosts stay light. */
export function isWebsiteThemedPath(pathname: string): boolean {
  return isWebsitePath(pathname) || pathname === "/login";
}

/** Website pages without dark mode: the demo booking flow stays light, the stored choice is ignored. */
export function isLightOnlyWebsitePath(pathname: string): boolean {
  return pathname === "/demo" || pathname.startsWith("/demo/");
}
